var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 458,
    viewBox: "0 0 540 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 135,
    r: 135,
    fill: "#224754"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 323,
    r: 135,
    fill: "#5A3F27"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 323,
    r: 135,
    fill: "#45411D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 135,
    r: 135,
    fill: "#2B503E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/Ellipse.a4ec93edc69cb185d49a3235189c01ea.svg";
export { ForwardRef as ReactComponent };